export type LinkWindowCounts = {
    sevenDays: number;
    thirtyDays: number;
    ninetyDays: number;
    all: number;
};

export type CampaignLinkTarget = {
    path: string;
    label: string;
    kind: 'page' | 'collection' | 'photo' | 'privateCollection' | 'privatePhoto';
};

export type CampaignLinkRow = {
    code: string;
    label: string;
    targetPath: string;
    targetLabel: string | null;
    url: string;
    channel: string;
    createdUtc: string;
    archivedUtc: string | null;
    scans: LinkWindowCounts;
    visits: LinkWindowCounts;
};

export type CampaignLinksResponse = {
    links: CampaignLinkRow[];
    targets: CampaignLinkTarget[];
};

/** Groups the target picker's options in the order the server lists them: pages, collections, photographs, then private ones. */
export function groupLinkTargets(targets: readonly CampaignLinkTarget[]): [CampaignLinkTarget['kind'], CampaignLinkTarget[]][] {
    const groups = new Map<CampaignLinkTarget['kind'], CampaignLinkTarget[]>();
    for (const target of targets) {
        const group = groups.get(target.kind);
        if (group == null) groups.set(target.kind, [target]);
        else group.push(target);
    }
    return [...groups.entries()];
}

/** Active links first, then newest first, matching the server's order after an archive or restore. */
export function sortCampaignLinks(links: readonly CampaignLinkRow[]): CampaignLinkRow[] {
    return [...links].sort((left, right) =>
        Number(left.archivedUtc != null) - Number(right.archivedUtc != null)
        || right.createdUtc.localeCompare(left.createdUtc)
        || left.code.localeCompare(right.code));
}

/** The QR code download for a link, served only to a signed-in administrator. */
export function getQrCodeDownloadUrl(code: string): string {
    return `/api/admin/links/${encodeURIComponent(code)}/qr.png`;
}
